const PLAN_DIFF_STORAGE_VERSION = '2';
const PLAN_DIFF_STORAGE_VERSION_KEY = 'studly.planDiff.storageVersion';
export const PLAN_DIFF_DRAW_TIP_KEY = 'studly.planDiff.drawTipDismissed';

/** Keys used by older Plan Diff builds that should never auto-resume. */
const LEGACY_PLAN_DIFF_KEYS = [
  'studly.planDiff.activeJobId',
  'studly.planDiff.activeJob',
  'studly.planDiff.resumeJobId',
];

const PRESERVE_PLAN_DIFF_KEYS = new Set([
  PLAN_DIFF_STORAGE_VERSION_KEY,
  PLAN_DIFF_DRAW_TIP_KEY,
]);

/**
 * Clears legacy Plan Diff browser state once per version bump.
 * Safe to call on every app boot — no-ops after migration for this version.
 */
export function migratePlanDiffClientState() {
  if (typeof window === 'undefined' || !window.localStorage) return;

  try {
    const current = window.localStorage.getItem(PLAN_DIFF_STORAGE_VERSION_KEY);
    if (current === PLAN_DIFF_STORAGE_VERSION) return;

    LEGACY_PLAN_DIFF_KEYS.forEach((key) => {
      window.localStorage.removeItem(key);
    });

    // Also drop any other studly.planDiff.* keys from older experiments.
    const toRemove = [];
    for (let i = 0; i < window.localStorage.length; i += 1) {
      const key = window.localStorage.key(i);
      if (key && key.startsWith('studly.planDiff.') && !PRESERVE_PLAN_DIFF_KEYS.has(key)) {
        toRemove.push(key);
      }
    }
    toRemove.forEach((key) => window.localStorage.removeItem(key));

    window.localStorage.setItem(PLAN_DIFF_STORAGE_VERSION_KEY, PLAN_DIFF_STORAGE_VERSION);
  } catch {
    // Private mode / quota — ignore; Plan Diff no longer depends on localStorage.
  }
}

export function isPlanDiffDrawTipDismissed() {
  try {
    return window.localStorage?.getItem(PLAN_DIFF_DRAW_TIP_KEY) === '1';
  } catch {
    return false;
  }
}

export function dismissPlanDiffDrawTip() {
  try {
    window.localStorage?.setItem(PLAN_DIFF_DRAW_TIP_KEY, '1');
  } catch {
    // ignore
  }
}
